module.exports = __webpack_public_path__ + "img/17.e5770402.png";